module.exports = __webpack_public_path__ + "static/img/egg_g_01.436b30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_01.png
// module id = rGTl
// module chunks = 1